module.exports = __webpack_public_path__ + "img/CameraZOOM-20210712092055588.f5c44905.jpg";